export enum enmParameterType {
    TEXT = 1,
    TEXTAREA = 2,
    CHECKBOX = 4,
    SELECT = 7,
    DATE = 8,
    DATE_RANGE = 9
}